import getSelectedFolderView from './getSelectedFolderView';
import TodoFolderViewState from '../store/schema/TodoFolderViewState';

export default function getSelectedFolderViewState(): TodoFolderViewState {
    const folderView = getSelectedFolderView();

    return folderView ? folderView.folderViewState : null;
}
